<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'560px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  components: { Wxts },
  name: "VehicleGroup",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'cararray',
      breadcrumb: [
        { name: "车辆管理" },
        { name: "车队分组" },
      ],
      wxtsList: [
        {
          name: '该处对车辆进行分组，设置不同分组内单台车的目标运费额和目标净利率，目标运费额和目标净利率用于计算车队运费额和净利额的达成率。'
        },
      ],
      con: '',
      formInline: {},
      formCtrl: [
        {
          label: "分组名",
          keyName: "arrname",
          placeholder: "请填写分组名",
          type: "text",
        }
      ],
      cols: [
        { keyName: "arrname", label: "车组名称", minwidth: 120 },
        { keyName: "carcount", label: "车辆数量", minwidth: 110 },
        { keyName: "sort", label: "排序", minwidth: 110 },
        { keyName: "mbfreight", label: "目标运费额", minwidth: 120 },
        { keyName: "mbmlv", label: "目标净利率", minwidth: 120 },
        { keyName: "addtime", label: "添加时间", minwidth: 120 },
      ],
      btns: [
        {
          class: 'viewlistbtn',
          title: '查看列表',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ id }) => {
            // console.log(id)
            this.$router.push(`/vehicle/groupList/table/${id}`)
          },
        },
        {
          ...this.editBtn,
          cb: ({ id, arrname, mbfreight, mbmlv, sort }) => {
            // console.log(id)
            this.title = '修改车组'
            if (mbmlv) {
              mbmlv = mbmlv.slice(0, -1)
              mbmlv = Number(mbmlv)
            }
            this.mform = { ...this.mform, id, arrname, mbfreight, mbmlv, sort }
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '车组设置',
      viewMode: false,
      mform: {
        mbfreight: undefined
      },
      mrules: {
        arrname: [
          {
            required: true,
            message: '请填写车组名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "车组名称",
          keyName: "arrname",
          err: "请填写车组名称",
          type: "text",
          tips: '车组名称最好为中文',
        },
        {
          label: "目标运费额",
          keyName: "mbfreight",
          err: "请填写目标运费额",
          type: "number",
          // tips: '车组名称最好为中文',
          unit: "元",
        },
        {
          label: "目标净利率",
          keyName: "mbmlv",
          err: "请填写目标净利率",
          type: "number",
          // tips: '车组名称最好为中文',
          unit: "%",
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写序号",
          type: "number",
          tips: '数字越大排序越靠前',
        },
      ],
      delUrl: 'delarray',
    };
  },
  methods: {
    addItem() {
      this.title = '添加车组'
      this.mform = {
        arrname: undefined,
        nickname: undefined,
      }
      this.showDialog()
    },
    getList(staticfresh) {
      this.loading = true
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        console.log(res.data)
        res.data.map(v => {
          console.log(v)
          if (v.mbmlv) {
            v.mbmlv = v.mbmlv + '%'
          }
        })
        this.tableDataHandler(res);
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        ...data,
      }
      // if (params.mbmlv.length > 2) {
      //   this.$message({
      //     type: 'error',
      //     message: '目标净利率请输入小于等于两位的整数',
      //   });
      //   return
      // }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    getFleet() {
      this.post(`base/getmyfleet`, {}, this.setFleet, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setFleet({ team }) {
      console.log(team)
      this.mformCtrl.map(c => {
        if (c.keyName == 'nickname') {
          c.options = team.map(v => {
            return {
              label: v.nickname,
              value: v.id,
            }
          })
        }
      })
      this.$forceUpdate()
    },
  },
  mounted() {
    this.getFleet();
    const { user_group_id } = this.user
    if ([5].includes(user_group_id)) {
      this.btns = this.btns.slice(1)
    }
  }
};
</script>

<style lang="less" scoped>
.dialog {
  /deep/ .el-dialog {

    .el-form {
      margin: 16px 66px 50px;

      .el-input,
      .el-textarea {
        width: 230px;
      }
    }

    .btns .mians {
      text-align: center;
    }
  }
}

/deep/ .wxts {
  .b {
    width: 290px;
  }
}
</style>
